import {getRadians} from '../../utils';


// ----- ships settings -----

export const ships = {
    bulk: 'bulk',
    tanker: 'tanker',
    passenger: 'passenger',
    container: 'container',
    offshore: 'offshore',
    lubricant: 'lubricant'
};

export const ship3D = [ships.bulk];

export const ships2D = [ships.tanker, ships.passenger, ships.offshore, ships.container, ships.lubricant];

export const areasNamesMap = {
    superstructure: 'superstructure',
    mooringRopes: 'mooringRopes',
    mooringRopesFront: 'mooringRopesFront',
    engineRoom: 'engineRoom',
    ballastWaterTank: 'ballastWaterTank',
    cargoHold: 'cargoHold',
    deck: 'deck',
    exhaustGasBoiler: 'exhaustGasBoiler',
    fuelOilTank: 'fuelOilTank'
};

export const areaHotspotsSettings =
    {
        superstructure: {
            name: areasNamesMap.superstructure,
            coordinates: {x: 5.3, y: 1.6, z: -0.03},
            cameraCoordinates: {x: 8.95, y: 2.38, z: 1.15},
        },
        mooringRopes: {
            name: areasNamesMap.mooringRopes,
            coordinates: {x: 6.8, y: 1, z: -0.06},
            cameraCoordinates: {x: 8.46, y: 1.57, z: 0.67}
        },
        mooringRopesFront: {
            name: areasNamesMap.mooringRopes,
            coordinates: {x: -7, y: 1.1, z: -0.04},
            cameraCoordinates: {x: -10, y: 2.51, z: -1.77}
        },
        engineRoom: {
            name: areasNamesMap.engineRoom,
            coordinates: {x: 5.4, y: 0.3, z: 0.4},
            cameraCoordinates: {x: 8.85, y: 2.5, z: 3.7}
        },
        ballastWaterTank: {
            name: areasNamesMap.ballastWaterTank,
            coordinates: {x: 3, y: 0.3, z: 0.9},
            cameraCoordinates: {x: 8.25, y: 2.83, z: 4.17}
        },
        cargoHold: {
            name: areasNamesMap.cargoHold,
            coordinates: {x: 0.7, y: 1.12, z: -0.03},
            cameraCoordinates: {x: 4.15, y: 5.38, z: 4.23}
        },
        deck: {
            name: areasNamesMap.deck,
            coordinates: {x: -3, y:0.95, z: 0.85},
            cameraCoordinates: {x: -7, y: 3.38, z: -2}
        },
        exhaustGasBoiler: {
            name: areasNamesMap.exhaustGasBoiler,
            coordinates: {x: 6, y: 1.9, z: -0.05},
            cameraCoordinates: {x: 8.95, y: 2.38, z: 1.15},
        },
        fuelOilTank: {
            name: areasNamesMap.fuelOilTank,
            coordinates: {x: 0.7, y: 0.5, z: 0.9},
            cameraCoordinates: {x: 4.15, y: 3, z: 7}
        }
};



// ----- three.js camera settings -----

export const cameraLoadingPosition = {
    x: 4.3,
    y: 9,
    z: 46
};

export const cameraInitialPosition = {
    x: -4.3,
    y: 9,
    z: 13
};

export const cameraTransitionSpeed = 1500;

export const initialOrbitControlsSettings = {
    minDistance: 8,
    maxDistance: 20,
    dampingFactor: 0.2,
    enableDamping: true,
    enableKeys: false,
    enablePan: false,
    minAzimuthAngle: -Infinity,
    maxAzimuthAngle: Infinity,
    minPolarAngle: getRadians(-90),
    maxPolarAngle: getRadians(90),
    rotateSpeed: 0.25
};